import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
/**
 * Storage service
 * provides a service for persistent storage in the app.
 * 
 * [see ionic docs]{@link https://github.com/ionic-team/ionic-storage}
 */
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  /**
   * storage object to use
   */
  private _storage: Storage | null = null;
  private storageLoaded : boolean = false;
  /**
   * @ignore
   */
  constructor(
    private storage: Storage
  ) {
    this.init();
  }

  /**
   * so we can check if db is init and created
   * @returns promise with truth when ready
   */
  isReady(){
    let self = this;
    var promise = new Promise(function(resolve, reject){
      var myTimeout = setInterval(() => {
        // console.log("🚀 ~ file: database.service.ts:98 ~ DatabaseService ~ myTimeout ~ self.dbLoaded:", self.dbLoaded)
        if( self.storageLoaded ){
          clearTimeout(myTimeout);
          resolve( true );
        }else{
        }
      }, 100 );
    });

    return promise;
  }


  /**
   * When the service inits
   * - Create storage
   * - set it to _storage
   */
  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    if( this._storage === null ){
      const storage = await this.storage.create();
      this._storage = storage;
      this.storageLoaded = true;
    }
  }
  /**
   * Create and expose methods that users of this service can use
   * Sets a storage key value
   * @param key 
   * @param value 
   */
  async set(key: string, value: any) {
    await this._storage?.set(key, value);
  }
  /**
   * Gets a value from storage
   * @param key 
   * @returns 
   */
  async get(key: string ) {
    await this.isReady();
    //console.log("🚀 ~ file: storage.service.ts:32 ~ StorageService ~ get ~ key:", key)
    let val = await this._storage?.get( key );
    return val;
  }
  /**
   * removes a value from storage
   * @param key 
   */
  async remove(key: string ) {
    await this._storage?.remove( key );
  }
  /**
   * clears current storage
   */
  async clear( ) {
    await this._storage?.clear(  );
  }
  /**
   * gets storage keys
   */
  async keys( ) {
    await this._storage?.keys(  );
  }
  /**
   * gets lnegth of current storage
   */
  async length( ) {
    await this._storage?.length(  );
  }


  /**
   * gets all key values and adds to an array
  * @returns array
   */
  async getAll(){
    let returnValue: any = {};
    await this._storage?.forEach(( value,key, index) => {
      returnValue[ key ] = value;
    });
    return returnValue ;
  }
 


}


